import Modal from '../../../components/Modal';
import { DEFAULT_MAX_DURATION_SEC, DEFAULT_MIN_DURATION_SEC } from '../../../utils/videoLimits';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface InsertShotForm {
  duration: number;
  prompt: string;
}

interface InsertShotModalProps {
  insertAfterIndex: number | null;
  insertShotData: InsertShotForm;
  insertingShotLoading: boolean;
  t: Translate;
  onClose: () => void;
  onInsert: () => void;
  onInsertShotDataChange: React.Dispatch<React.SetStateAction<InsertShotForm>>;
  minDuration?: number;
  maxDuration?: number;
}

export default function InsertShotModal({
  insertAfterIndex,
  insertShotData,
  insertingShotLoading,
  t,
  onClose,
  onInsert,
  onInsertShotDataChange,
  minDuration = DEFAULT_MIN_DURATION_SEC,
  maxDuration = DEFAULT_MAX_DURATION_SEC,
}: InsertShotModalProps) {
  return (
    <Modal
      open={insertAfterIndex !== null}
      onClose={onClose}
      title={insertAfterIndex === 0 ? t('insertModal.titleFront') : t('insertModal.titleAfter', { index: insertAfterIndex })}
      width="480px"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose} disabled={insertingShotLoading}>{t('cancel', { ns: 'common' })}</button>
          <button className="btn btn-primary" onClick={onInsert} disabled={insertingShotLoading}>
            {insertingShotLoading ? <><span className="loading-spinner"></span>{t('insertModal.inserting')}</> : t('insertModal.insertShot')}
          </button>
        </>
      }
    >
      <div className="form-group">
        <label className="form-label">{t('shot.durationLabel')}</label>
        <input type="number" className="input" min={minDuration} max={maxDuration} value={insertShotData.duration} onChange={(event) => onInsertShotDataChange({ ...insertShotData, duration: Number(event.target.value) })} />
      </div>
      <div className="form-group">
        <label className="form-label">{t('shot.promptLabel')}</label>
        <textarea className="input textarea" style={{ minHeight: '100px' }} value={insertShotData.prompt} onChange={(event) => onInsertShotDataChange({ ...insertShotData, prompt: event.target.value })} placeholder={t('insertModal.promptPlaceholder')} />
      </div>
    </Modal>
  );
}
